<template>
  <div class="tab-content">
    <!-- 基本信息内容 -->
    <div class="basic-info-section">

      <!-- 测试车辆区域 -->
      <div class="info-area">
        <h3 class="area-title">测试车辆</h3>
        <a-table
            :columns="vehicleColumns"
            :data-source="testVehicles"
            :pagination="false"
            rowKey="id"
            size="middle"
        >
          <template #bodyCell="{ column, record }">
            <template v-if="column.key === 'type'">
              {{ record.type ? props.vehicleTypeList.find(item => item.id === record.type)?.name : '-' }}
            </template>
            <template v-if="column.key === 'color'">
              {{ record.color }}
            </template>
            <template v-if="column.key === 'actions'">
              <span>
                <a-button style="padding: 0 5px" class="action-btn" type="link" @click="openCarDetailModal(record)">详情</a-button>
                <a-button style="padding: 0 5px"  class="action-btn" type="link" danger>编辑</a-button>
              </span>
            </template>
          </template>
        </a-table>
      </div>

    </div>
    <!-- 车辆详情弹框 -->
    <VehicleDetailModal
        :visible="vehicleDetailModalVisible"
        :vehicle-type-list="props.vehicleTypeList"
        :vehicle="selectedVehicle"
        @update:visible="(value) => vehicleDetailModalVisible = value"
    />
    <VehicleEditModal
        :visible="vehicleEditModalVisible"
        :vehicle-type-list="props.vehicleTypeList"
        :vehicle="selectedVehicle"
        @update:visible="(value) => vehicleEditModalVisible = value"
        @save="handleVehicleSave"
    />
  </div>
</template>

<script setup name="BasicInfoTab">
import { defineProps, ref, onMounted } from 'vue';
import { getApplicationVehicleByApplicationId } from "@/api/application/applicationVehicles";
import VehicleDetailModal from '../intelligent/components/VehicleDetailModal.vue';
import VehicleEditModal from '../intelligent/components/VehicleEditModal.vue';

const props = defineProps({
  id: {
    type: String,
    required: true
  },
  vehicleTypeList: {
    type: Array,
    default: () => ([])
  },
});

// 测试车辆数据
const testVehicles = ref([]);

const selectedVehicle = ref({});
// 车辆详情弹框相关
const vehicleDetailModalVisible = ref(false);
// 打开车辆详情弹框
const openCarDetailModal = (car) => {
  selectedVehicle.value = { ...car };
  vehicleDetailModalVisible.value = true;
};

// 车辆编辑弹框相关
const vehicleEditModalVisible = ref(false);

const handleVehicleSave = (vehicle) => {

}

// 车辆表格列定义
const vehicleColumns = [
  {
    title: '车辆识别代码',
    dataIndex: 'vin',
    key: 'vin',
    width: 160
  },
  {
    title: '生产企业',
    dataIndex: 'manufacturer',
    key: 'manufacturer',
    width: 200
  },
  {
    title: '车辆型号',
    dataIndex: 'model',
    key: 'model',
    width: 100
  },
  {
    title: '车辆类型',
    dataIndex: 'type',
    key: 'type',
    width: 100
  },
  {
    title: '颜色',
    dataIndex: 'color',
    key: 'color',
    width: 60
  },
  {
    title: '发动机编号',
    dataIndex: 'vin',
    key: 'vin',
    width: 100
  },
  {
    title: '动力形式',
    dataIndex: 'powerType',
    key: 'powerType',
    width: 100
  },
  {
    title: '生产日期',
    dataIndex: 'productionDate',
    key: 'productionDate',
    width: 100
  },
  {
    title: '操作',
    dataIndex: 'actions',
    key: 'actions',
    width: 120
  }
];


const getVehicles = async () => {
  getApplicationVehicleByApplicationId(props.id).then((res) => {
    testVehicles.value = res.data;
  });
}

// 组件挂载时获取数据
onMounted(async () => {
  try {
    await getVehicles(props.id);
  } catch (error) {
    console.error('获取申请车辆信息失败:', error);
  }
});
</script>

<style scoped>
.tab-content {
  background: #fff;
  margin-bottom: 80px;
}

.basic-info-section {
  background: #fff;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 4px;
}

.info-area {
  margin-bottom: 20px;
  padding: 10px;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  background-color: #fafafa;
}

.area-title {
  margin-top: 0;
  padding-bottom: 5px;
  border-bottom: 2px solid #d9d9d9;
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

/* 确保表格样式合适 */
:deep(.ant-table) {
  margin-top: 10px;
}

:deep(.ant-table-thead > tr > th) {
  background-color: #fafafa;
  font-weight: 600;
  color: #333;
}
</style>